export enum BadgeFilterTypesEnum {
    VERIFIED = 'VERIFIED',
    UPDATED = 'UPDATED',
    MUTLIPLE_EMPLOYMENTS = 'MULTIPLE_EMPLOYMENTS',
    LONGSTANDING = 'LONGSTANDING',
    NEW_EMPLOYMENT = 'NEW_EMPLOYMENT',
    NEW_ENTITY = 'NEW_ENTITY',
    AI_REFERENCE = 'AI_REFERENCE'
}

export interface BadgeFilterModel {
    type: BadgeFilterTypesEnum;
    since: Date;
    before: Date;
}
